const contactData = {
  pageHeading: "Contact Us",
  introText: "ASRM & CO. — Chartered Accountants. Reach out to us at any of our offices for financial, audit, tax, and corporate law consultancy.",
  offices: [
    {
      id: 1,
      label: "Head Office (Shri Vijaya Puram (Port Blair))",
      address: "232 M G Road, Lamba Line, Shri Vijaya Puram (Port Blair)- 744103, Andaman & Nicobar Island",
      city: "Shri Vijaya Puram (Port Blair)",
      state: "Andaman & Nicobar Island",
      pincode: "744103",
      phone: [],
      mobile: ["+91 - 7003443644"],
      fax: "",
      email: ["asrm.andaman@gmail.com"],
      mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3907.5889620796415!2d92.731735!3d11.652611!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0!2zMTHCsDM5JzA5LjQiTiA5MsKwNDMnNTUuMyJF!5e0!3m2!1sen!2sin!4v1663586226594!5m2!1sen!2sin"
    },
    {
      id: 2,
      label: "Branch Office (Kolkata)",
      address: "67A Metcalfe Street, Floor – 2, Room – 2, Kolkata – 700013, West Bengal",
      city: "Kolkata",
      state: "West Bengal",
      pincode: "700013",
      phone: ["033-40650048"],
      mobile: ["+91-9831050547"],
      fax: "",
      email: ["capransukhka@gmail.com", "asrm.kol13@gmail.com"],
      mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.2581478163715!2d88.35227051443397!3d22.56944633877544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0277af349e283f%3A0xe0c098a8968e6e67!2sFloor%20%E2%80%93%202%2C%20Room%20%E2%80%93%202%2C%2067A%2C%20Metcalfe%20St%2C%20Mission%20Row%20Extension%2C%20Esplanade%2C%20Bowbazar%2C%20Kolkata%2C%20West%20Bengal%20700013!5e0!3m2!1sen!2sin!4v1663324910686!5m2!1sen!2sin"
    },
    {
      id: 3,
      label: "Branch Office (Asansol)",
      address: "Silicate Factory Road, Suryasis Apartment, 1st floor flat no B, Durga Mandir, Asansol 713303",
      city: "Asansol",
      state: "West Bengal",
      pincode: "713303",
      phone: ["0341 2302425"],
      mobile: ["+91 - 7001497635"],
      fax: "",
      email: ["asrm.asansol@gmail.com"],
      mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3653.9181617087997!2d86.99156567533375!3d23.678884478719233!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDQwJzQ0LjAiTiA4NsKwNTknMzguOSJF!5e0!3m2!1sen!2sin!4v1739185247321!5m2!1sen!2sin"
    }
  ],
  businessHours: "Monday – Saturday: 10:00 AM – 7:00 PM IST",
  socialMedia: {
    facebook: "https://www.facebook.com/ASRM-CO-486599011395267/",
    instagram: "https://www.instagram.com/asrmco.asansol?igsh=bDk2M2g1dzZjdmg0",
    linkedin: "https://www.linkedin.com/company/asrm-co/"
  }
};

export default contactData;
